import React from 'react';
import {Redirect, withRouter} from 'react-router-dom';
import {Dimmer, Loader} from 'semantic-ui-react';
import {Alert} from 'componentLibrary';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {
  STATUS_PENDING_SUBMISSION,
  STATUS_SUBMITTED_TO_FEMA,
} from 'app-ui-componentlibrary/dist/common/constants';
import _ from 'lodash';
import REST from 'go/requests/rest';
import {getTimestampNowISO} from 'common/utils';

class InitiateSubCloseoutReportModal extends React.Component {
  state = {
    open: false,
    cancelling: false,
    message: '',
    selectedGrantId: '',
  };

  componentDidMount() {
    this.refreshData();
  }

  componentDidUpdate(prevProps) {
    this.refreshData();
  }

  refreshData() {
    const {open, token, entity, entityType} = this.props;
    const {selectedGrantId} = this.state;
    let subGrantId = entity.subGrantId;

    if (!_.isEqual(selectedGrantId, subGrantId)) {
      this.setState({
        selectedGrantId: subGrantId,
        message: '',
        open: this.props.open,
        entityType: entityType,
      });
    } else if (!_.isEqual(open, this.state.open)) {
      this.setState({open: this.props.open});
    }
  }

  handleCancel = () => {
    const cancel = () => this.props.onCancel();
    this.setState({open: false});
    cancel();
  };

  handleConfirm = () => {
    const {token, entity} = this.props;
    const {entityType, selectedGrantId, message} = this.state;
    let currentDate = getTimestampNowISO();
    const data = {
      entityId: selectedGrantId,
      statusTimestamp: currentDate,
      status: 'closeoutInitiated',
    };
    const callbackMethod = (allowed) => {
      if (_.isEmpty(message)) {
        if (allowed) {
          this.setState({
            open: false,
            cancelling: false,
            message:
              'You can not initiate closeout with Payments or Amendments in "Submitted to FEMA" status, if a Closeout report exists, or if Property data mitigation is in "Pending submission" status.',
          });
        } else {
          this.createEntity(entityType);
          REST.dynamicData
            .patchEntity(token, data)
            .then(REST.handler.handleResponse)
            .then(() => {
              this.setState({open: false, cancelling: false, message: ''});
              this.props.onCancel();
            })
            .catch((error) => {
              this.setState({
                cancelling: false,
                message:
                  'An error happened while trying to patch the status for this subgrant.',
              });
              console.error(
                'An error happened while trying to patch the status for this subgrant: '
              );
            });
        }
      } else {
        this.setState({open: false, cancelling: true, message: ''});
        window.location.reload(false);
      }
    };

    this.setState({cancelling: true, message: ''});
    this.checkToContinueCloseout(selectedGrantId, callbackMethod);
  };

  checkToContinueCloseout(subGrantId, callback) {
    const {token, onError} = this.props;
    let amendments = [];
    let payments = [];
    let subCloseoutReports = [];
    let propertyData = [];

    REST.dynamicData
      .getBySubGrantIdAndEntityType(token, subGrantId, 'subAmendmentRecommendation')
      .then(REST.handler.handleResponse)
      .then((data) => {
        if (data && data.status) {
          amendments.push(data.status);
        } else {
          _.map(data, (amendment) => {
            amendments.push(amendment.status);
          });
        }
      })
      .then(() => {
        REST.dynamicData
          .getBySubGrantIdAndEntityType(token, subGrantId, 'payment')
          .then(REST.handler.handleResponse)
          .then((data) => {
            if (data && data.status) {
              payments.push(data.status);
            } else {
              _.map(data, (payment) => {
                payments.push(payment.status);
              });
            }
          });
      })
      .then(() =>
        REST.dynamicData
          .getBySubGrantIdAndEntityType(token, subGrantId, 'propertyData')
          .then(REST.handler.handleResponse)
          .then((data) => {
            if (data && data.status) {
              propertyData.push(data.status);
            } else {
              _.map(data, (data) => {
                propertyData.push(data.status);
              });
            }
          })
      )
      .then(() => {
        REST.dynamicData
          .getBySubGrantIdAndEntityType(token, subGrantId, 'subCloseoutReport')
          .then(REST.handler.handleResponse)
          .then((data) => {
            if (data && data.status) {
              subCloseoutReports.push(data.status);
            } else {
              _.map(data, (subCloseoutReport) => {
                subCloseoutReports.push(subCloseoutReport.status);
              });
            }

            let holdCloseout =
              _.includes(amendments, STATUS_SUBMITTED_TO_FEMA) ||
              _.includes(payments, STATUS_SUBMITTED_TO_FEMA) ||
              _.includes(propertyData, STATUS_PENDING_SUBMISSION) ||
              !_.isEmpty(subCloseoutReports);

            callback(holdCloseout);
          });
      })
      .catch((error) => {
        this.setState({
          cancelling: false,
          message:
            'An error happened while trying to create the subCloseoutReport entity for this subgrant.',
        });
        console.error(
          'An error happened while trying to create the subCloseoutReport entity for this subgrant: '
        );
      });
  }

  createEntity(entityType) {
    const {token, onError} = this.props;
    const {selectedGrantId} = this.state;

    REST.dynamicData
      .createEntityFromSubGrant(token, selectedGrantId, entityType)
      .then(REST.handler.handleResponse)
      .then((entityData) => {
        if (entityData.errors != null) {
          onError(entityData);
        } else {
          this.setState({
            entityType: entityData.entityType,
            entityId: entityData.entityId,
          });
        }
      })
      .catch((error) => {
        this.setState({
          cancelling: false,
          message:
            'An error happened while trying to create the closeoutReport entity for this grant.',
        });
        console.error(
          'An error happened while trying to create the closeoutReport entity for this grant: '
        );
      });
  }

  render() {
    const {entity} = this.props;
    const {open, cancelling, message, entityType, entityId} = this.state;

    if (entityId && entityType) {
      return <Redirect to={`/${entityType}/${entityId}/edit`} push />;
    }
    return (
      open && (
        <FemaGoModal
          type="alert"
          size="medium"
          title="Initiate subgrant closeout"
          className="modal-title"
          open={open}
          confirmAction={this.handleConfirm}
          buttonText="Confirm"
          cancelButtonText="Cancel"
          buttonType={'primary'}
          cancelAction={this.handleCancel}
        >
          <hr />
          {!_.isEmpty(message) && (
            <Alert header="" htmlContent={message} alertType="error" />
          )}
          {cancelling && (
            <Dimmer active>
              <Loader />
            </Dimmer>
          )}
          <p>
            <strong>{`Subgrant ID:  ${entity.subGrantId}`}</strong>
          </p>
          <p>
            {`Before initiate subgrant closeout, you should complete all post-award activities for this subgrant and be ready to enter the closeout phase. Obligation of additional funds can only be handled through an amendment and not in the closeout phase. In the closeout phase, any payments issued through FEMA GO will be issued after the FEMA review of your subgrant closeout report which may take some time, and the amendment feature will be disabled. If you have immediate cash needs, please submit a payment request prior to initiating closeout. If you need prior approval from FEMA on any outstanding issues, please submit an amendment prior to initiating closeout. You will be able to return to the post-award phase if necessary to re-enable the FEMA GO payment and amendment features, but you will lose any work you have performed on your subgrant closeout report.`}
          </p>
          <br />
        </FemaGoModal>
      )
    );
  }
}

export default withRouter(InitiateSubCloseoutReportModal);
